<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import {FulfillingBouncingCircleSpinner} from "epic-spinners";
import vSelect from "vue-select";
import moment from 'moment';
import "vue-select/dist/vue-select.css";
// import moment from "moment";
// import Switches from "vue-switches";
import Datepicker from 'vuejs-datepicker';
// import DatePicker from "vue2-datepicker";
import {es} from 'vuejs-datepicker/dist/locale';
Vue.component("v-select", vSelect);
import { required } from "vuelidate/lib/validators";

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import {mapState} from "vuex";
import {authComputed} from "@/state/helpers";

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Listado de Procesos de Gestacion de cerdos",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    datepicker: Datepicker,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    // Switches,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // DatePicker,
  },
  data() {
    return {
      
      razasDeCerdos : [
        { nombre: "Duroc" },
      { nombre: "Tri-Linea" },
    { nombre: "Landrace" },
    { nombre: "Pietrain" },
    { nombre: "Hampshire" },
    { nombre: "Chester White" },
    { nombre: "TN60" },
    { nombre: "TN70" },
      ],
      formPro : {
        raza : null,
        fecha: new Date() ,
      },
      es :es,
      disabledDates: {
          to: '',
      },
      swAnular: false,
      
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      metododeBusqueda: false,
      fecha_inicio: "",
      rangode_fecha: "",
      fecha_fin: "",
      bandera_fecha: false,
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "inseminaciones/getAll",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formVenta: {
        total: "",
        cliente: "",
        nombre: "",
        descripcion: "",
        tiendaid: "",
        state: true,
        id: 0,
      },
      tiendasData: [],
      updating: false,
      estadotabla: true,
      title: "Gestación de cerdos",
      itemst: [
        {
          text: "Gestación de cerdos",
          href: "/",
        },
        {
          text: "Listado",
          active: true,
        },
      ],
      fields: [
      {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          // width: "10%",
        },
        {
          name: "cerdo",
          title: "No. Cerdo",
          sortField: "cerdo",
          // width: "15%",
        },
        {
          name: "envia.no_lote",
          title: "No. Lote",
          sortField: "envia.no_lote",
          // width: "15%",
        },
        {
          name: "cerdo_padre",
          title: "Verraco",
          sortField: "cerdo_padre",
          // width: "15%",
        },
        {
          name: "embarazo",
          title: "Preñez",
          titleClass: "",
          dataClass: "text-muted",
          // width: "10%",
        },
        {
          name: "fechac1",
          title: "Fecha Traslado",
          sortField: "fechac1",
          // width: "15%",
        },
        {
          name: "fechac2",
          title: "Fecha P. Parto",
          sortField: "fechac2",
          // width: "15%",
        },
        // {
        //   name: "no_inseminacion",
        //   title: "Inseminación",
        //   sortField: "no_inseminacion",
        //   // width: "5%",
        // },

        {
          name: "fechac",
          title: "Fecha Inseminación",
          sortField: "fechac",
          // width: "15%",
        },
        
        // {
        //   name: "lote_envia",
        //   title: "Lote Salida",
        //   sortField: "lote_envia",
        //   // width: "15%",
        // },
        // {
        //   name: "lote_recibe",
        //   title: "Lote Entrada",
        //   sortField: "lote_recibe",
        //   // width: "15%",
        // },
        

        {
          name: "costos",
          title: "Costos",
          sortField: "costos",
          // width: "5%",
        },
        {
          name: "empleado",
          title: "Empleado",
          sortField: "empleado",
          // width: "10%",
        },
        
        {
          name: "proceso",
          title: "Proceso",
          titleClass: "",
          dataClass: "text-muted",
          // width: "10%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          // width: "10%",
        },
        
        
      ],
      searchType: [
        {nombre: "No. Cerdo", value: "no_cerdo"},
        {nombre: "No. Gestación", value: "no_inseminacion"},
        {nombre: "Fecha Gestación", value: "fecha"},
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "no_cerdo",
      sortDesc: false,
      searchLabel:  {nombre: "No. Cerdo", value: "no_cerdo"},
      filterLabel: {nombre: "No. Cerdo", value: "no_cerdo"},
      showModalL: false, //Loading
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      showModalF: false, //Finalizar
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      showModalN: false ,
      costos_inseminacion: 0,
      formInseminacion : {
        fecha : '',
        fecha_posible_parto: '',
        fecha_traslado: '',
        idEnvia: '',
        idRecibe :  '',
        cerdoId:'',
        userId : ''
      }
    };
  },
  validations: {
    formPro : {
      raza : {
        required,
      },
      fecha : {
        required,
      },
    },
    costos_inseminacion : {
      required,
    },
  },
  mounted() {
    // console.log('hola')
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {"x-token": usuario.token},
      })
          .then((res) => {
            if (res.data.success) {
              // this.$router.push("/");
            }
          })
          .catch(() => {
            this.logout();
            location.reload();
          });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    activarBuscadorFechas(search){
      // console.log(search);
      this.bandera_fecha = (search.value == "fecha") ? true : false;
      // console.log(this.bandera_fecha)
    },
    formatoPresentacion(date) {
      return moment(date).locale("es").format("LL");
    // return moment(date).locale("es").format("LLLL");
    },
    updateDisableDates(){
      let me = this;
      if(new Date(me.customFormatter(me.fecha_inicio)).getTime() > new Date(me.customFormatter(me.fecha_fin))){
          me.$refs.myDatepicker.clearDate();
          me.fecha_fin = '';
      }
      me.disabledDates.to = new Date(me.fecha_inicio);
    },
    // customFormatter(date) {
    //   return moment(date).format('YYYY-MM-DD');
    // },
    limpiarfiltro(){
        let me = this;
        me.fecha_inicio = "";
        me.fecha_fin = "";
    },
    anularVenta() {
      // console.log(this.formVenta);
      axios
          .put(
              process.env.VUE_APP_URL + "ventas/anular",
              {
                id: this.formVenta.id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            this.$refs.vuetable.refresh();
            this.$refs["modalAnular"].hide();
          
            Vue.toasted.error(
                "Venta anulada",
                this.options
            );
       
            this.swAnular = false;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
      // .finally(() => {

      // });
    },
    sumarDias(dias, fecha) {
  // Si la fecha es null o undefined, usar la fecha actual
      
      let nuevaFecha = fecha ? new Date(fecha) : new Date();

      // Sumar los días
      nuevaFecha.setDate(nuevaFecha.getDate() + dias);

      return nuevaFecha;
    },

   
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
        if (!date) {
        return "";
        }
        return moment(date).locale("es").format("MMM Do YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    validarFecha(fecha) {
      let hoy = moment(new Date());
      let vec = moment(fecha);
      if (hoy > vec) {
        return true;
      } else {
        return false;
      }
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      // console.log("PaginationData", paginationData);
      // this.page = paginationData.current_page;
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;

      // if (this.$refs.pagination) {
        // this.$refs.pagination.setPaginationData(paginationData);
      // }
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    async changeTypeDates(fecha_inicio, fecha_fin) {
      // await this.separarfechas();
      this.fecha_inicio = fecha_inicio;
      this.fecha_fin = fecha_fin;
      this.$refs.vuetable.refresh();
    },
    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.fecha_inicio = type.value == "fecha" ? this.fecha_inicio : "";
      this.fecha_fin = type.value == "fecha" ?     this.fecha_fin : "";
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    changeTipoVenta(type) {
      this.tipo_label = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      console.log('entra', currentPage, this.page)
      return sortOrder[0]
          ? {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
                ? sortOrder[0].sortField
                : this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage ,
            limite: this.perPage,
            search: this.search,
          }
          : {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
                ? sortOrder[0].sortField
                : this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage ,
            limite: this.perPage,
            search: this.search,
          };
    },
    validaciones(opc) {
      this.submitted = true;
      if(opc == "embarazo"){
          this.embarazo();
        }
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if(opc == "embarazo"){
          this.embarazo();
        }
      }
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formVenta.id = 0;
      this.formVenta.descripcion = "";
      this.formVenta.nombre = "";
      this.formVenta.tiendaid = null;
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    async save() {
      const {fecha_traslado,fecha_posible_parto,idEnvia,idRecibe,cerdoId,userId, id} = this.formInseminacion;

      axios
        .post(
          process.env.VUE_APP_URL + "inseminaciones/reinseminacion",
          {
            id,
            fecha_posible_parto: fecha_posible_parto,
            fecha_traslado : fecha_traslado,
            idEnvia : idEnvia,
            cerdo_padre : this.formPro.raza.nombre,
            idRecibe : idRecibe ,
            cerdoId : cerdoId,
            costos_inseminacion: this.costos_inseminacion,
            userId:userId,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Registro Guardado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
          this.costos_inseminacion = 0;
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;

        });
    },
    async embarazo() {
      const {idEnvia,idRecibe,cerdoId,userId, id} = this.formInseminacion;

      
      axios
        .put(
          process.env.VUE_APP_URL + "inseminaciones/cambio_embarazo",
          {
            id,
            fecha :  this.formPro.fecha,
            fecha_posible_parto: this.sumarDias(114,this.formPro.fecha ),
            fecha_traslado : this.sumarDias(104,this.formPro.fecha ),
            idEnvia : idEnvia,
            idRecibe : idRecibe ,
            cerdoId : cerdoId,
            costos_inseminacion: this.costos_inseminacion,
            userId:userId,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Registro Guardado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
          // this.onChangePage(currentPage);
          this.costos_inseminacion = 0;
          this.showModalF = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;

        });
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "aprobar-item") {
        // console.log(data);
        this.formInseminacion.fecha_traslado = this.sumarDias(104);
        this.formInseminacion.fecha_posible_parto = this.sumarDias(114);
        this.formInseminacion.idEnvia= data.idEnvia;
        this.formInseminacion.idRecibe = data.idRecibe;
        this.formInseminacion.cerdoId = data.cerdoId;
        this.formInseminacion.userId = this.userT.id;
        this.formInseminacion.id = data.id;
        this.showModalN = true;
      }
      if (action == "aprobar-embarazo") {
        // console.log(data);
        this.formInseminacion.fecha_traslado = this.sumarDias(104);
        this.formInseminacion.fecha_posible_parto = this.sumarDias(114);
        this.formInseminacion.idEnvia= data.idEnvia;
        this.formInseminacion.idRecibe = data.idRecibe;
        this.formInseminacion.cerdoId = data.cerdoId;
        this.formInseminacion.userId = this.userT.id;
        this.formInseminacion.id = data.id;
        this.showModalF = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style  scoped>
/* Css para el loading en el modal */
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* Para una mejor experiencia en dispositivos móviles */
}

.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst"/>

    <div class="row">
      <div class="col-12">
    
        <b-modal
            centered
            v-model="showModalL"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
            no-close-on-backdrop
            content-class="my-class"
            header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                      :animation-duration="2000"
                      :size="90"
                      color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <b-modal
          centered
          v-model="showModalN"
          title="Nuevo Proceso Gestación"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form @submit.prevent="validaciones('save')">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Costos por Gestación</label>

                  <input
                    id="name"
                    v-model="$v.costos_inseminacion.$model"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese los costos de insimenación"
                    :class="{
                      'is-invalid': $v.costos_inseminacion.$error,
                    }"
                    @input="$v.costos_inseminacion.$touch()"
                  />

                  <div
                    v-if="
                      $v.costos_inseminacion.$error &&
                      !$v.costos_inseminacion.required
                    "
                    class="invalid-feedback"
                  >
                    Los costos de Gestación son obligatorios.
                  </div>
                </div>
                <div class="mb-3">
                         
                         <label>Raza Animal Padre</label>
                   <v-select
                       v-model.trim="$v.formPro.raza.$model"
                       :state="!$v.formPro.raza.$error"
                       :options="razasDeCerdos"
                       label="nombre"
                   ></v-select>
                   <div
                       :class="{
                       'invalid-feedback': true,
                       'd-block':
                         $v.formPro.raza.$error && !$v.formPro.raza.required,
                     }"
                   >
                     Debe seleccionar una raza de animal
                   </div>
                       </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>
        <b-modal
          centered
          v-model="showModalF"
          title="Aprobar Verraco"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form @submit.prevent="validaciones('embarazo')">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Fecha Inseminación</label>
                  <datepicker
                            v-model.trim="$v.formPro.fecha.$model"
                            :state="!$v.formPro.fecha.$error"

                            styling="true"
                            :format="formatoPresentacion"
                             input-class="form-control"
                             :language="es"
                              lang="es"
                              :disabled-dates="{
                              from: new Date(new Date().setHours(23, 59, 59, 999)) // Bloquea desde el final del día actual en adelante
                              }"
                          ></datepicker>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalF = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Procesos de Gestacion</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        @input="changePageSize()"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>
           

              <div class="col-sm-12 col-md-2">
                <div
                    id="tickets-table_length"
                    class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                          v-for="(search, index) in searchType"
                          :key="index"
                          @click="changeTypeSearch(search), activarBuscadorFechas(search, index);"
                      >{{ search.nombre }}
                      </b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-2 text-md-start" v-if="!bandera_fecha">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                        v-model="search"
                        type="search"
                        @input="onFiltered()"
                        placeholder="Buscar..."
                        class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-4" v-if="!bandera_fecha">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <label class="d-inline-flex align-items-center">
                      <router-link
                          :to="{
                          name: 'new_inseminacion',
                        }"
                      >
                        <button
                            v-b-modal.modalSave
                            type="button"
                            class="btn btn-success btn-rounded mb-2 me-2"
                        >
                          <b>NUEVO PROCESO GESTACIÓN</b>&nbsp;&nbsp;<i
                            class="bx bxs-plus-circle"
                        ></i>
                        </button>
                      </router-link>
                    </label>
                  </label>
                </div>
              </div>
                <!-- Campo de fecha de inicio -->
                <div class="col-sm-12 col-md-3" v-if="bandera_fecha">
                  <!-- <label for="startDate" class="form-label">Fecha de inicio:</label> -->
                  <datepicker :bootstrap-styling="true"
                   @input="updateDisableDates()" placeholder="Fecha inicio" 
                   :language="es" :format="customFormatter" v-model="fecha_inicio"></datepicker>
                </div>

                <!-- Campo de fecha de fin -->
                <div class="col-sm-12 col-md-3" v-if="bandera_fecha">
                  <!-- <label for="endDate" class="form-label">Fecha de fin:</label> -->
                  <datepicker :bootstrap-styling="true" @input="changeTypeDates(fecha_inicio, fecha_fin)"  ref="myDatepicker" 
                  placeholder="Fecha fin" :disabledDates="disabledDates" :language="es" :format="customFormatter" v-model="fecha_fin"></datepicker>

                </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <div class="table-responsive">
              <vuetable
                  ref="vuetable"
                  class="table-divided order-with-arrow"
                  :css="css.table"
                  :api-url="apiBase"
                  :reactive-api-url="true"
                  :fields="fields"
                  :per-page="perPage"
                  :http-options="httpOptions"
                  :query-params="makeQueryParams"
                  pagination-path
                  @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-dropdown
                      text="Opciones"
                      variant="outline-primary"
                      size="sm"
                  >
                    <!-- Anular -->
                    <b-dropdown-item-button
                     v-if="props.rowData.estado_embarazo == false && props.rowData.estado_activo == true"
                        @click="onActionClicked('aprobar-item', props.rowData)"
                        variant="outline-success"
                    >
                        <i class="bx bx-repeat"></i>&nbsp;&nbsp;&nbsp;&nbsp;Reinseminación
                    </b-dropdown-item-button>
                    <b-dropdown-item-button
                    v-if="props.rowData.estado_embarazo == false && props.rowData.estado_activo == true"
                        @click="onActionClicked('aprobar-embarazo', props.rowData)"
                        variant="outline-success"
                    >
                        <i class="bx bx-heart"></i>&nbsp;&nbsp;&nbsp;&nbsp;Preñez
                    </b-dropdown-item-button>
                    <router-link
                    :to="{
                      name: 'view_inseminacion',
                      params: { id: props.rowData.cerdoId },
                    }"
                  >
                    <b-dropdown-item-button
                        variant="outline-success"
                    >
                        <i class="bx bx-show"></i>&nbsp;&nbsp;&nbsp;&nbsp;Ver mas
                    </b-dropdown-item-button>

                   
                  </router-link>

                  </b-dropdown>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado == true">
                    <span class="badge bg-success ms-1"
                    ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                    ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="embarazo" slot-scope="props">
                  <h5 v-if="props.rowData.estado_embarazo == true">
                    <span class="badge bg-success ms-1"
                    ><strong>Preñado</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                    ><strong>Pendiente</strong></span
                    >
                  </h5>
                </div>

                
                <div slot="empleado" slot-scope="props">
                  {{ props.rowData.user.usuario }}
                  <!-- {{ props.rowData.user.empleado.persona.apellido_persona }} -->
                </div>
                <div slot="fechac" slot-scope="props">
                  {{showDate(props.rowData.fecha) }}
                </div>
                <div slot="fechac1" slot-scope="props">
                  {{showDate(props.rowData.fecha_traslado) }}
                </div>
                <div slot="fechac2" slot-scope="props">
                  {{showDate(props.rowData.fecha_posible_parto) }}
                </div>
                <div slot="lote_envia" slot-scope="props">
                  {{(props.rowData.envia.no_lote) }}
                </div>
                <div slot="lote_recibe" slot-scope="props">
                  {{(props.rowData.recibe.no_lote) }}
                </div>
                <div slot="cerdo" slot-scope="props">
                  {{(props.rowData.cerdo.codigo) }}
                </div>
                <div slot="proceso" slot-scope="props">
                  {{(props.rowData.estado_proceso) }}
                </div>
                <div slot="costos" slot-scope="props">
                  {{money(props.rowData.costos) }}
                </div>
              </vuetable>
            </div>
              <div style="padding-top: 10px">
                <vuetable-pagination
                    ref="pagination"
                    :css="css.pagination"
                    @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
/* Estilo general */
.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

.card-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

/* Botones y entradas */
.btn-rounded {
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.btn-rounded:hover {
  transform: scale(1.05);
}

.table-responsive {
  overflow-x: auto;
}

.table-divided {
  width: 100%;
  border-collapse: collapse;
}

.table-divided th,
.table-divided td {
  text-align: center;
  padding: 8px;
  border: 1px solid #ddd;
}

.badge {
  font-size: 0.8rem;
  padding: 5px 10px;
  border-radius: 12px;
}

/* Ajustes para pantallas medianas */
@media (max-width: 992px) {
  .card-title {
    font-size: 1.3rem;
  }

  .btn-rounded {
    padding: 6px 15px;
    font-size: 0.85rem;
  }
}

/* Ajustes para tablets */
@media (max-width: 768px) {
  .row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .col-sm-12 {
    width: 100%;
    margin-bottom: 10px;
  }

  .dataTables_length {
    text-align: center;
    margin-bottom: 10px;
  }

  .btn {
    width: 100%;
    text-align: center;
  }

  .table-responsive {
    overflow-x: auto;
  }

  .card-title {
    font-size: 1.2rem;
  }
}

/* Ajustes para móviles */
@media (max-width: 576px) {
  .card-title {
    font-size: 1rem;
  }

  .btn-rounded {
    padding: 5px 10px;
    font-size: 0.8rem;
  }

  .badge {
    font-size: 0.7rem;
    padding: 3px 8px;
  }

  .row {
    flex-direction: column;
    align-items: center;
  }

  .dataTables_length label {
    width: 100%;
    text-align: center;
  }

  .table-divided th,
  .table-divided td {
    font-size: 0.8rem;
    padding: 5px;
  }
}

/* Ajustes para tablets y móviles */
@media (max-width: 992px) {
  .card-title {
    font-size: 1.4rem;
    text-align: center;
  }

  .btn-rounded {
    font-size: 0.85rem;
    padding: 7px 15px;
  }

  .row {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .col-sm-12 {
    width: 100%;
    margin-bottom: 10px;
  }

  .dataTables_length {
    text-align: center;
    margin-bottom: 10px;
  }

  .btn {
    width: 100%;
    text-align: center;
  }

  .table-divided th,
  .table-divided td {
    font-size: 0.9rem;
    padding: 6px;
  }
}

/* Ajustes para móviles */
@media (max-width: 576px) {
  .card {
    padding: 10px;
  }

  .card-title {
    font-size: 1.2rem;
  }

  .btn-rounded {
    font-size: 0.8rem;
    padding: 5px 10px;
  }

  .badge {
    font-size: 0.7rem;
    padding: 3px 8px;
  }

  .row {
    flex-direction: column;
    align-items: center;
  }

  .dataTables_length label {
    width: 100%;
    text-align: center;
  }

  .table-divided th,
  .table-divided td {
    font-size: 0.8rem;
    padding: 5px;
  }
}
</style>

